var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileUploading = function SvgFileUploading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#0A8CBB",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20 23.826c.576 0 1.044.467 1.044 1.044v2.086a1.044 1.044 0 0 1-2.088 0V24.87c0-.577.468-1.044 1.044-1.044m3.555-1.348c.277 0 .543.109.74.305l1.479 1.478a1.046 1.046 0 1 1-1.481 1.477l-1.476-1.476a1.043 1.043 0 0 1 0-1.475c.195-.197.46-.308.738-.309m-7.06-.03a1.044 1.044 0 0 1 .738 1.78l-1.476 1.476a1.044 1.044 0 0 1-1.479-1.472l1.476-1.476c.196-.196.461-.306.738-.305zm-1.365-3.492a1.044 1.044 0 0 1 0 2.088h-2.087a1.044 1.044 0 0 1 0-2.088zm11.826 0a1.044 1.044 0 0 1 0 2.088H24.87A1.044 1.044 0 0 1 23.826 20l.006-.114c.057-.523.5-.93 1.038-.93zm-12.502-4.532a1.07 1.07 0 0 1 1.476 0l1.476 1.476a1.044 1.044 0 0 1-.737 1.78l-.138-.009a1.04 1.04 0 0 1-.6-.296L14.453 15.9l-.087-.098a1.044 1.044 0 0 1 .087-1.378m10.446-.4.126.008a1.044 1.044 0 0 1 .613 1.774l-1.476 1.475a1.043 1.043 0 0 1-1.475 0l-.09-.104a1.044 1.044 0 0 1 .09-1.373l1.475-1.475c.195-.196.46-.306.737-.305M20 12c.576 0 1.044.467 1.044 1.043v2.087a1.044 1.044 0 0 1-2.088 0v-2.087c0-.576.468-1.043 1.044-1.043",
    clipRule: "evenodd"
  })));
};
export default SvgFileUploading;